<template>
  <div>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="">
        <div class="radioForm">
          <!-- <div class="radioWrap">
            <el-radio v-model="searchData.lifting_time" label="created_at"
              >創建時間</el-radio
            >
            <el-radio v-model="searchData.lifting_time" label="completed_at"
              >完成時間</el-radio
            >
          </div> -->
          <el-date-picker
            :picker-options="{ disabledDate: $store.state.disabledDate }"
            v-model="currentDate"
            placeholder="選擇日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="高代號" v-if="$store.state.userStatus != 'agent'">
        <el-input v-model="searchData.agent_id" placeholder="高代號"></el-input>
      </el-form-item>
      <el-form-item label="商戶號">
        <el-select
          v-model="searchData.customer_id"
          filterable
          placeholder="請選擇商戶號"
        >
          <el-option value="" label="全部"> </el-option>
          <el-option
            v-for="customer in customerList"
            :key="customer.user_id"
            :value="customer.user_id"
            :label="customer.user_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="顯示模式">
        <el-select v-model="searchData.mode" placeholder="顯示模式">
          <el-option label="商戶渠道" value="0"> </el-option>
          <el-option label="三方渠道" value="1"> </el-option>
          <el-option label="代理渠道(僅支持代收)" value="2"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <h2 class="title">代收</h2>
    <el-table
      show-summary
      sum-text="合計"
      stripe
      :data="dataList"
      :summary-method="getSummaries"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="渠道名稱"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="success"
        label="成功金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="real_amount"
        label="真實金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.real_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="amount_customer"
        label="實收金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.amount_customer | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="fee"
        label="手續費"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="success_count"
        label="成功筆數"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success_count | thousands || 0 }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <h2 class="title">代付</h2>
    <el-table
      show-summary
      sum-text="合計"
      stripe
      :data="payments"
      :summary-method="getSummaries"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="渠道名稱"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="success"
        label="成功金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="success_count"
        label="成功筆數"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success_count | thousands || 0 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="reversal"
        label="沖正金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.reversal | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="reversal_count"
        label="沖正筆數"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.reversal_count | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <h2 class="title" style="margin-top:15px">提現</h2>
    <el-table
      show-summary
      sum-text="合計"
      stripe
      :data="withdrawDataList"
      :summary-method="getSummaries"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        header-align="center"
        align="center"
        prop="name"
        label="渠道名稱"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="success"
        label="成功金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="real_amount"
        label="真實金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.real_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="amount_customer"
        label="實收金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.amount_customer | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="fee"
        label="手續費"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="success_count"
        label="成功筆數"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.success_count | thousands || 0 }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {
        mode: "0",
        lifting_time: "completed_at"
      },
      dataList: [],
      currentData: {},
      currentDate: [],
      customerList: [],
      withdrawDataList: [],
      payments: []
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合計";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });
      sums.forEach((num, index) => {
        if (typeof num == "number") {
          sums[index] = this.$options.filters["thousands"](
            this.$options.filters["decimalPoint"](num)
          );
        }
      });
      return sums;
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/statistics/order`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            let dataList = res.data.data.transactions;
            dataList.forEach(e => {
              e.fee =
                (e.real_amount * 1000 * 1 - e.amount_customer * 1000 * 1) /
                1000;
            });
            this.dataList = dataList;

            let withdrawDataList = res.data.data.withdraws;
            withdrawDataList.forEach(e => {
              e.fee =
                (e.real_amount * 1000 * 1 - e.amount_customer * 1000 * 1) /
                1000;
            });
            this.withdrawDataList = withdrawDataList;
            let payments = res.data.data.payments;
            this.payments = payments;
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
          }
        });
    }
  },
  created() {
    this.$http.get(`/back/customers`).then(res => {
      if (res.data.code == 0) {
        this.customerList = res.data.data;
      }
    });
  }
};
</script>
